/**
 * Format a golf_clubs row for display. Multi-course clubs render as
 * "{name} - {course_name}" (em dash); single-course clubs render as just
 * "{name}". A course_name is treated as a duplicate of the club name when
 * the two strings match after stripping common trailing tags
 * ("Golf Club" / "Club" / "GC" on the name side, "Golf Course" / "Course" /
 * "Links" on the course side) — that case also collapses to just "{name}",
 * so "Mytton Fold Golf Club" + "Mytton Fold Golf Course" renders as
 * "Mytton Fold Golf Club" rather than the doubled-up form.
 *
 * Accepts a full row, a partial row, or null.
 */

const CLUB_SUFFIXES = ['golf club', 'g\\.?c\\.?', 'club'];
const COURSE_SUFFIXES = ['golf course', 'course', 'links'];

function stripTrailing(value, suffixes) {
  if (!value) return '';
  return value
    .trim()
    .replace(new RegExp(`\\s+(${suffixes.join('|')})\\s*$`, 'i'), '')
    .trim()
    .toLowerCase();
}

export function formatClubDisplayName(club) {
  if (!club?.name) return '';
  if (!club.course_name) return club.name;

  const clubCore = stripTrailing(club.name, CLUB_SUFFIXES);
  const courseCore = stripTrailing(club.course_name, COURSE_SUFFIXES);
  if (clubCore && clubCore === courseCore) return club.name;

  return `${club.name} - ${club.course_name}`;
}
